import React from 'react';
import { TextField } from '@rmwc/textfield';
import { List, ListItem } from '@rmwc/list';
import Icon from './Icon';
import Divider from './Divider';
import { Fade, ClickAwayListener } from '../decorators/index';
import IconButton from './IconButton';
/**
 * Search Component, hidden input and icon
 */
export default function RootSearch(_a) {
    var open = _a.open, setOpen = _a.setOpen, _b = _a.icon, icon = _b === void 0 ? 'search' : _b;
    var _c = React.useState(false), focus = _c[0], setFocus = _c[1];
    var show = function () {
        setTimeout(function () { return setOpen(true); }, 0);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { icon: icon, label: "search", className: open ? 'active' : '', onChange: show }),
        React.createElement(Fade, { active: open, timeout: 200, className: "madonna-root-search-container" },
            React.createElement(ClickAwayListener, { clickAway: function () { setOpen(false); }, className: "madonna-root-search" },
                React.createElement(Icon, { icon: "search", size: "small" }),
                React.createElement(TextField, { placeholder: "  Search your intranet", className: "text-field", onFocus: function () { setFocus(true); }, onBlur: function () { setFocus(false); } }),
                React.createElement(Icon, { icon: "close", size: "small", onClick: function () { return setOpen(false); } }),
                focus && (React.createElement("div", { className: "suggestions" },
                    React.createElement("div", { className: "suggestions-title" }, "Recent searches"),
                    React.createElement(List, { className: "madonna-suggestions-list" },
                        React.createElement(ListItem, { className: "madonna-suggestions-list-item" }, "Row text"),
                        React.createElement(ListItem, { className: "madonna-suggestions-list-item" }, "Row text"),
                        React.createElement(ListItem, { className: "madonna-suggestions-list-item" }, "Row text"),
                        React.createElement(ListItem, { className: "madonna-suggestions-list-item" }, "Row text")),
                    React.createElement(Divider, { color: "#dcdcdc" }),
                    React.createElement("div", { className: "suggestions-title" }, "Saved searches"),
                    React.createElement(List, { className: "madonna-suggestions-list" },
                        React.createElement(ListItem, { className: "madonna-suggestions-list-item" }, "Row text"))))))));
}
//# sourceMappingURL=RootSearch.js.map